/**
 * Pricing data for the Pricing page
 * Centralized location for easy maintenance and updates
 */

export const pricingPackages = [
  {
    id: 'diy',
    name: 'DIY',
    subtitle: 'Self Navigator',
    price: '400,000',
    refundable: 'Non-refundable',
    description: 'For confident self-starters who want expert verification',
    features: [
      'Document verification for up to 5 countries',
      'SOP/CV/LoR format standards + 1 feedback round',
      'Portal access & status tracking',
      'Eligibility assessment',
      'Profile setup',
      'Document checklists'
    ],
    cta: 'Choose DIY',
    link: '/wizard',
    popular: false
  },
  {
    id: 'plus',
    name: 'Plus',
    subtitle: 'Guided Success',
    price: '850,000',
    refundable: 'Partially refundable',
    description: 'End-to-end handling for one country with premium essentials',
    features: [
      'Everything in DIY',
      'Full university + visa management for 1 country',
      'SOP/LoR editing & application management',
      'Visa documentation & appointment support',
      'Public health insurance setup (DE)',
      'Blocked account setup & guidance (DE)',
      'Study Loan Assistance (Canada): Up to 75% tuition',
      'Referral commission LKR 25,000 per referral',
      'Structured payment (60% / 40%)'
    ],
    highlight: 'Germany health insurance & blocked account included',
    cta: 'Choose Plus',
    link: '/wizard',
    popular: false
  },
  {
    id: 'pro',
    name: 'PRO',
    subtitle: 'All-Inclusive Elite',
    price: '1,190,000',
    refundable: 'Partially refundable',
    description: 'Maximum safety, global reach, and VIP support across all 5 countries',
    features: [
      'Everything in Plus',
      'Multi-country coverage (all 5 included)',
      'Minimum 7 university applications (5 public + 2 private)',
      'Application Success Guarantee: Free re-application (worth LKR 850,000)',
      'Dedicated consultant with priority support',
      'Free IELTS preparation course (worth LKR 80,000)',
      'Travel insurance (first month) included',
      'Student & alumni network access',
      'Referral commission LKR 50,000 per referral',
      '25% Family Visa Discount — spouse/dependents',
      '100GB cloud storage with dedicated email',
      'Google Gemini Pro for 1 year with 2TB storage',
      'Structured payment (40% / 30% / 30%)'
    ],
    highlight: 'Most Popular - Best Value',
    cta: 'Go PRO',
    link: '/wizard',
    popular: true
  }
];

export const packageComparison = [
  {
    feature: 'Countries Covered',
    diy: 'Up to 5',
    plus: '1 Country',
    pro: 'All 5 Countries'
  },
  {
    feature: 'University Applications',
    diy: 'DIY Support',
    plus: 'Managed',
    pro: 'Min. 7 Applications'
  },
  {
    feature: 'Document Verification',
    diy: '✓',
    plus: '✓',
    pro: '✓'
  },
  {
    feature: 'SOP/CV/LoR Support',
    diy: 'Format Standards',
    plus: 'Full Editing',
    pro: 'Full Editing + Priority'
  },
  {
    feature: 'Visa Management',
    diy: 'DIY',
    plus: '✓',
    pro: '✓'
  },
  {
    feature: 'Germany Insurance Setup',
    diy: '—',
    plus: '✓',
    pro: '✓'
  },
  {
    feature: 'Blocked Account Support',
    diy: '—',
    plus: '✓',
    pro: '✓'
  },
  {
    feature: 'Study Loan Assistance',
    diy: '—',
    plus: 'Canada Only',
    pro: 'Canada Only'
  },
  {
    feature: 'IELTS Preparation',
    diy: '—',
    plus: '—',
    pro: 'Free (Worth LKR 80K)'
  },
  {
    feature: 'Family Visa Discount',
    diy: '—',
    plus: '—',
    pro: '25% Off'
  },
  {
    feature: 'Cloud Storage',
    diy: '—',
    plus: '—',
    pro: '100GB + Dedicated Email'
  },
  {
    feature: 'AI Assistant',
    diy: '—',
    plus: '—',
    pro: 'Google Gemini Pro (1 Year)'
  }
];

/**
 * Pricing highlights
 */
export const pricingHighlights = [
  {
    title: 'Transparent Pricing',
    value: '100%',
    description: 'No hidden fees',
    icon: '💰'
  },
  {
    title: 'Refund Options',
    value: '2',
    description: 'Packages available',
    icon: '↩️'
  },
  {
    title: 'Payment Plans',
    value: '3',
    description: 'Flexible options',
    icon: '💳'
  },
  {
    title: 'Countries',
    value: '5',
    description: 'Germany, Canada, Australia, UK, NZ',
    icon: '🌍'
  }
];
